import React, { Component, PropTypes } from 'react';
import './CustomControlWrapper.scss';

export default class CustomControlWrapper extends Component {
  static propTypes = {
    closeCustomControl: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
  };

  render() {
    const { closeCustomControl, children } = this.props;

    return (
      <div className="custom-control">
        <div onClick={closeCustomControl} className="custom-control__screen" />
        <div className="custom-control__body">
          { children }
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/layouts/CustomControlLayout/CustomControlWrapper.jsx
 **/